'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _highcharts = require('../library/highcharts');

var _validation = require('../library/validation');

var _log = require('../library/log');

var log = _interopRequireWildcard(_log);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    name: 'breakdown',

    template: require('./breakdown.component.html'),

    props: {
        data: {
            validator: (0, _validation.jsonSchemaPropValidator)(require('../schema/breakdown-array.schema.json'))
        },
        title: String,

        // The maximum number of data points,
        // when exceed this limit points will be summed up into a new point 'others'
        limit: { type: Number, default: 0 }
    },

    data: function data() {
        return {
            chart: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        (0, _highcharts.initializeHighstocks)().then(function (Highcharts) {
            return _this.chart = _this.initializeChart(Highcharts);
        }, function (e) {
            return log.error('breakdown', 'mounted', e);
        });
    },


    methods: {

        /**
         * Initializes the pie chart.
         * @param Highcharts
         * @returns {Highcharts}
         */
        initializeChart: function initializeChart(Highcharts) {
            var chart = Highcharts.chart(this.$refs.chart, {
                series: [{
                    name: this.title,
                    colorByPoint: true,
                    data: []
                }],

                // Pie chart.
                chart: {
                    type: 'pie'
                },

                // Set title to the prop value
                title: {
                    text: null
                },

                // Simple tooltip format
                tooltip: {
                    formatter: function formatter() {
                        return '\n                                ' + this.point.name + ':\n                                <b>' + Highcharts.numberFormat(this.point.percentage) + '%</b>\n                            ';
                    }
                }
            });

            this.updateChart(this.data, chart);
            return chart;
        },


        /**
         * Updates the data in the current chart, respecting the limit of max points (`this.limit`).
         * @param data
         * @param chart
         */
        updateChart: function updateChart() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.data;
            var chart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.chart;

            var dataArray = [];

            if (this.limit != 0 && this.limit < data.length) {
                var othersPercent = 0;

                for (var i = 0; i < data.length; i++) {
                    if (i < this.limit - 1) {
                        dataArray.push({
                            name: data[i].label,
                            y: data[i].percentage
                        });
                    } else {
                        othersPercent += data[i].percentage;
                    }
                }
                dataArray.push({
                    name: 'Others',
                    y: Math.round(othersPercent * 100) / 100
                });
            } else {
                dataArray = data.map(function (d) {
                    return { name: d.label, y: d.percentage };
                });
            }

            chart.series[0].setData(dataArray);
        }
    },

    watch: {

        /**
         * Call the `updateChart` method, if the data changes.
         */
        data: {
            deep: true,
            handler: function handler(data) {
                if (!this.chart) {
                    return;
                }
                this.updateChart(data);
            }
        }

    }

};